export const ViceCaptainIcon = (props: {
  fill?: string;
  className?: string;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none" {...props}>
    <path
      d="M16.2704 7.25044L16.2674 7.21122H13.7121L12.4329 5.00581L13.7121 2.80041H16.237L17.786 0.217878L17.7769 0.205811H12.2056L9.41992 5.00581L12.2025 9.79978H17.7557L16.2704 7.25044Z"
      fill="white"
    />
    <path
      d="M8.08923 0.199951L5.55516 4.56551L3.02109 0.199951H0.0141602L4.05169 7.1601L5.55516 9.7547L7.06166 7.1601L11.0992 0.199951H8.08923Z"
      fill="white"
    />
  </svg>
);
